export enum MaterialQuantityOptionEnum {
    PARTS_LIST_QUANTITY = 'PARTS_LIST_QUANTITY',
    PRODUCTION_QUANTITY = 'PRODUCTION_QUANTITY',
}
